const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedLoyaltyPoint: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const loyaltypoint = (state = initialState, action) => {
	switch (action.type) {
		case 'LOYALTYPOINT_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'LOYALTYPOINT_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'LOYALTYPOINT_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'LOYALTYPOINT_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'LOYALTYPOINT_GET_CURRENT':
			return {
				...state,
				selectedLoyaltyPoint: action.selectedLoyaltyPoint,
			}
		case 'LOYALTYPOINT_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default loyaltypoint
